export default function PageContainer({ title, children, className = '', icon, rightElement, withoutContainer } : {
  title: string,
  children: React.ReactNode,
  className?: string
  icon?: React.ReactNode,
  rightElement?: React.ReactNode
  withoutContainer?: boolean
}) {
  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <div className={`${withoutContainer ? '':"container mx-auto"} px-4 py-8 sm:px-6 lg:px-8`}>
        <div className='flex justify-between'>
          <div className="flex items-center gap-1">
            {icon}
            <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
          </div>
          {rightElement}
        </div>
        <div className={`mt-4 ${className}`}>
          {children}
        </div>
      </div>
    </div>
  );
}